<nav class="bottom-nav">
  <!-- Home -->
  <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
    <sxw-svg-icon name="home" width="20px" height="20px" fillColor="#fff"></sxw-svg-icon>
    <span>{{ "mobileNav.home" | translate }}</span>
  </a>

  <!-- Credits -->
  <a class="nav-item" routerLink="/payment" routerLinkActive="active">
    <div class="nav-item-with-badge-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="8" cy="8" r="6" />
        <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
        <path d="M7 6h1v4" />
        <path d="m16.71 13.88.7.71-2.82 2.82" />
      </svg>
      <span class="nav-badge credits-count-badge">
        @if ((creditService.creditDetails()?.totalAvailableCredits ?? 0) < 9999) {
          {{ creditService.creditDetails()?.totalAvailableCredits }}
        } @else {
          ∞
        }
      </span>
    </div>
    <span>{{ "mobileNav.credit" | translate }}</span>
  </a>

  <!-- Chat -->
  <a class="nav-item" routerLink="/messages" routerLinkActive="active">
    <div class="nav-item-with-badge-container">
      <sxw-svg-icon width="20px" height="20px" name="message"></sxw-svg-icon>
      @if (chatService.unseenMessages()) {
        <span class="nav-badge messages-count-badge">{{ chatService.unseenMessages() }}</span>
      }
    </div>
    <span>{{ "mobileNav.chat" | translate }}</span>
  </a>

  <!-- Account -->
  <div class="nav-item">
    <sxw-svg-icon width="20px" height="20px" name="user" fillColor="#fff" strokeColor="#fff" (click)="toggleUserMenu()"></sxw-svg-icon>
    <span>{{ "mobileNav.account" | translate }}</span>

    @if (showUserMenu) {
      <div class="bottom-user-menu">
        <button (click)="goToProfile()">{{ "mobileNav.profile" | translate }}</button>
        <button (click)="goToBilling()">{{ "mobileNav.billing" | translate }}</button>
        <button (click)="goToUpdateMyProperty()">{{ "mobileNav.property" | translate }}</button>
        <button class="danger" (click)="logout()">{{ "mobileNav.logout" | translate }}</button>
      </div>
    }
  </div>
</nav>
